<template>
  <div>
    <div ref="linecharts" style="width: 100%; height: 400px"></div>
  </div>
</template>

<script>
export default {
  props: { webData: Object },
  watch: {
    webData(val, newval) {
      this.dataProcessing()
      console.log(this.webData);
    },
  },
  data() {
    return {
      seriesData:[],
      label: {
        show: true,
        formatter: [
          "{a|{b} }", //引导线上面文字
          "{b|}", //引导线下面文字
        ].join("\n"), //用\n来换行
        // fontSize: "14",
        // fontWeight: "300",
        color: "#434343",
        position: "outside",
        //a和b来识别不同的文字区域
        rich: {
          a: {
            left: 50,
            top: -10,
            padding: [10, -10, -30, -10],
            fontWeight: "300",
            fontSize: "14",
          },
          b: {
            height: 5,
            width: 5,
            lineHeight: 5,
            marginBottom: 10,
            padding: [0, -5],
            borderRadius: 5,
            borderWidth: 1,
            borderColor: "#4E97D6",
          },
        },
      },
    };
  },
  methods: {
    dataProcessing() {
      this.seriesData=[]
      for (let key in this.webData.city_top10) {
        this.seriesData.push({
          value:this.webData.city_top10[key],
          label:this.label,
          name:key
        })
      }
      this.createEcharts()
      console.log(this.seriesData)
    },
    createEcharts() {
      let myChart = this.$echarts.init(this.$refs.linecharts);
      // 绘制图表
      myChart.setOption({
        tooltip: {
          backgroundColor: "rgba(50,50,50,0.9)",
          trigger: "item",
          formatter: "{b}: {c}\n ({d}%)",
          borderColor: "transparent",
          borderWidth: "5",
          textStyle: {
            fontSize: "12",
            lineHeight: "12",
            height: "10",
            color: "white",
          },
        },
        series: [
          {
            name: "访问来源",
            type: "pie",
            radius: ["40%", "70%"],
            avoidLabelOverlap: false,

            // data: [
            //   { value: 1048, name: "深圳", label: this.label },
            //   { value: 735, name: "上海", label: this.label },
            //   { value: 580, name: "杭州", label: this.label },
            //   { value: 484, name: "北京", label: this.label },
            //   { value: 300, name: "广州", label: this.label },
            // ],
            data:this.seriesData,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      });
    },
   
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/admin/index/HotCity.vue